import { CustomerObjectMapTypeResponseData } from "../../@types";
import * as Axios from "../../config/Axios";

export const fetchCustomers = (paginationToken?: string) => {
  return async () => {
    const params: Record<string, string> = {
      limit: "60",
    };
    if (paginationToken) params.paginationToken = paginationToken;
    const search = new URLSearchParams(params);
    return await Axios.get<CustomerObjectMapTypeResponseData>({
      path: `/organisations/users?${search}`,
    });
  };
};
